module.exports = __webpack_public_path__ + "images/youtube10e7c713a410fc612ef362deb86da4d1.png";